import { createContext, useReducer } from "react"
import { strings } from "../strings"
import { groupBy } from "underscore"

export const BookingsContext = createContext()

export const bookingsReducer = (state, action) => {
    switch (action.type) {
        case 'SET_BOOKINGS':
            return {
                bookings: action.payload,
                bookedLaundrySlots: state.bookedLaundrySlots,
                bookedBalconySlots: state.bookedBalconySlots,
                history: state.history
            }
        case 'SET_BOOKED_LAUNDRY_SLOTS':
            return {
                bookings: state.bookings,
                bookedLaundrySlots: action.payload,
                bookedBalconySlots: state.bookedBalconySlots,
                history: state.history
            }
        case 'SET_BOOKED_BALCONY_SLOTS':
            return {
                bookings: state.bookings,
                bookedLaundrySlots: state.bookedLaundrySlots,
                bookedBalconySlots: action.payload,
                history: state.history
            }
        case 'CREATE_BOOKING':
            const isBalconyBooking = action.payload.facility === strings.balcony.balcony
            return {
                bookings: [action.payload, ...state.bookings],
                bookedLaundrySlots: !isBalconyBooking ? [action.payload, ...state.bookedLaundrySlots] : state.bookedLaundrySlots,
                bookedBalconySlots: isBalconyBooking ? [action.payload, ...state.bookedBalconySlots] : state.bookedBalconySlots,
                history: state.history
            }
        case 'DELETE_BOOKING':
            return {
                bookings: state.bookings.filter(b => b._id !== action.payload._id),
                bookedLaundrySlots: state.bookedLaundrySlots,
                bookedBalconySlots: state.bookedBalconySlots,
                history: state.history
            }
        case 'SET_HISTORY':
            let groupedHistory = groupBy(action.payload, function(b) {
                return new Date(b.start).getFullYear()
            })

            return {
                bookings: state.bookings,
                bookedLaundrySlots: state.bookedLaundrySlots,
                bookedBalconySlots: state.bookedBalconySlots,
                history: groupedHistory
            }
        default:
            return state
    }
}

export const BookingsContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(bookingsReducer, {
        bookings: null,
        bookedLaundrySlots: null,
        bookedBalconySlots: null,
        history: null
    })

    return (
        <BookingsContext.Provider value={{ ...state, dispatch }}>
            {children}
        </BookingsContext.Provider>
    )
}